import { Center, Flex, FlexProps, useColorMode, useToken } from "@chakra-ui/react";
import { ReactNode } from "react";

import { RanaLogoPrimary } from "../../icons/ranaLogoPrimary";
import { RanaPageTitle } from "../../lib/components/rana-page-title";
import { SIZES } from "../../lib/theme/consts/sizing-consts";

export interface RanaAuthorisationBackgroundProps {
  pageSubTitle: ReactNode;
  logoMinWidth?: FlexProps["minWidth"];
  logoAlign?: "left" | "center";
}

export function RanaAuthorisationBackground({
  pageSubTitle,
  logoMinWidth,
  logoAlign = "center",
  children,
  ...rest
}: RanaAuthorisationBackgroundProps & FlexProps) {
  const [keepAnalytic, clearCreek, deepSea] = useToken("colors", [
    "brand.keep_analytic",
    "brand.clear_creek",
    "brand.deep_sea",
  ]);
  const lightMode = useColorMode().colorMode === "light";
  return (
    <Flex
      w="full"
      minH="vh"
      flexDir="column"
      alignItems="center"
      p={6}
      background={
        lightMode
          ? `linear-gradient(to right, white, ${clearCreek})`
          : `linear-gradient(to right, ${keepAnalytic}, black)`
      }
      color="brand.deep_sea"
      fontWeight={300}
      {...rest}
    >
      <RanaPageTitle subTitle={pageSubTitle} />
      <Center flex={1} flexDir="column">
        {logoMinWidth && (
          <Flex
            minWidth={logoMinWidth}
            mb={2}
            alignSelf={logoAlign === "left" ? "flex-start" : "center"}
            justifyContent={logoAlign === "left" ? "flex-start" : "center"}
          >
            <RanaLogoPrimary width={SIZES["sm"]} height={16} />
          </Flex>
        )}
        {children}
      </Center>
      <Center flexDir="column" mt={4}>
        <RanaLogoPrimary width={52} height={16} color={lightMode ? `${deepSea}` : "white"} />
      </Center>
    </Flex>
  );
}
